import { ref } from 'vue'

import { useCreateRelationSlideInStore } from '@/stores/createRelationSlideInStore'

const deleteModalOpen = ref(false)

const setDeleteModalOpen = (value: boolean): void => {
  deleteModalOpen.value = value
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/explicit-module-boundary-types
export const useRelationModals = () => {
  const createRelationSlideInStore = useCreateRelationSlideInStore()
  return {
    deleteModalOpen,
    setDeleteModalOpen,
    ...createRelationSlideInStore,
  }
}
